// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class RegisterAPI extends MainAPI {
	/**
	 * @param {*} registrationDetails - Contains userData and petData during registration
	 */
	async postRegister(registrationDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(registrationDetails.formDetails)
		);

		if (registrationDetails.petImg) {
			newFormData.append(
				'profileImage',
				registrationDetails.petImg
			);
		}
		
		if (registrationDetails.userImage) {
			newFormData.append(
				'userImage',
				registrationDetails.userImage
			);
		}
		
		return API.post(ENDPOINTS.POST_REGISTER, newFormData);
	}
}

export default new RegisterAPI();
